import { diff } from 'deep-object-diff';
import { useMemo } from 'react';

const DEFAULT_EXCLUDED_FIELDS = ['start', 'end'];

export const useUnsavedChanges = <T extends Record<string, unknown>>(
  defaultValues: T | null | undefined,
  currentValues: T | null | undefined,
  excludeFields: string[] = DEFAULT_EXCLUDED_FIELDS,
) => {
  return useMemo(() => {
    const formChanges = diff(defaultValues ?? {}, currentValues ?? {});
    const relevantChanges = Object.entries(formChanges).filter(([key]) => !excludeFields.includes(key));

    return relevantChanges.length > 0;
  }, [defaultValues, currentValues, excludeFields]);
};
